import React from "react";
import ReactDOM from "react-dom";

class FullPageBackground extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentNode: null
    };

    this._unmount = this._unmount.bind(this);
  }

  _unmount() {
    if (this.state.currentNode) {
      ReactDOM.unmountComponentAtNode(this.state.currentNode);
      this.state.currentNode.remove();
      this.setState({ currentNode: null });
    }
  }

  componentDidMount() {
    let node = document.createElement("div");
    document.body.insertBefore(node, document.body.childNodes[0]);
    this.setState({ currentNode: node }, () => {
      this.componentWillReceiveProps(this.props);
    });
  }

  componentWillReceiveProps(props) {
    if (!this.state.currentNode) {
      return;
    }

    let outerStyle = {
        position: "fixed",
        left: 0,
        right: 0,
        height: "100%",
        width: "100%",
        zIndex: -1,
        transform: "scale(1.1)"
      },
      innerStyle = {
        background: props.src
          ? `url('${props.src}') no-repeat center center`
          : undefined,
        backgroundSize: "cover",
        height: "100%",
        width: "100%",
        filter: "blur(20px)",
        WebkitFilter: "blur(20px)",
        MozFilter: "blur(20px)",
        OFilter: "blur(20px)",
        MsFilter: "blur(20px)",
        opacity: 0.75
      };

    ReactDOM.render(
      <div style={outerStyle}>
        <div style={innerStyle} />
      </div>,
      this.state.currentNode
    );
  }

  componentWillUnmount() {
    this._unmount();
  }

  render() {
    return null;
  }
}

export default FullPageBackground;



// WEBPACK FOOTER //
// ./src/app/components/partials/full-page-background.jsx